import { render, staticRenderFns } from "./BaseModalComponent.vue?vue&type=template&id=72a9abf8&scoped=true"
import script from "./BaseModalComponent.vue?vue&type=script&lang=js"
export * from "./BaseModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a9abf8",
  null
  
)

export default component.exports